import * as yup from 'yup'

export default yup.object().shape({
  mobile_phone: yup.string().required('O campo Celular é requerido.')
})
